import { useEffect } from "react";
import { useHistory } from "react-router";
function Logout() {
  const history = useHistory();

  useEffect(() => {
    localStorage.clear();
    history.push("/");
  }, [history]);

  return <></>;
}

export default Logout;
